/* eslint-disable import/no-anonymous-default-export */
import axiosInstance from "../axios/axios-configuration";
import { CancelToken } from "axios"
import { IMailbox, IAoo } from "../shared/interfaces";

const controller = 'Mailboxes';

const getMailboxes = (aooId: number, cancelToken?: CancelToken): Promise<any[]> => {
    return axiosInstance.get(`${controller}/${aooId}/GetMailboxes`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const addMailbox = (aooId: number, mailbox: Partial<IMailbox>, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.post(`${controller}/${aooId}/Add`, mailbox, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}


const deleteMailbox = (aooId: number, mailboxId: number, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.delete(`${controller}/${aooId}/Delete/${mailboxId}`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}


const updateMailbox = (aooId: number, mailboxId: number, mailbox: Partial<IMailbox>, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.put(`${controller}/${aooId}/Update/${mailboxId}`, mailbox, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

export default {
    getMailboxes,
    addMailbox,
    deleteMailbox,
    updateMailbox,
}
